import fetch from 'cross-fetch';

const getUploadURL = async () => {
  const getURLResponse = await fetch('https://pdfapi.rockdelux.com/production/get-upload-url', { method: 'GET' });

  if (getURLResponse.status >= 400) {
    throw new Error('Could not get S3 upload URL');
  }

  return getURLResponse.json();
};

const uploadPDF = async (file) => {
  const uploadData = await getUploadURL();

  if (uploadData.url) {
    const uploadResponse = await fetch(uploadData.url, { method: 'PUT', body: file });

    if (uploadResponse.status >= 400) {
      throw new Error('Could not upload file to S3');
    }

    return uploadData.key;
  }

  return null;
};

export default uploadPDF;
